if (process.env.NODE_ENV === 'development') {
    console.log("development env");
    module.exports = require('./dev');
} else if (process.env.NODE_ENV === 'production') {
    console.log("production env");
    module.exports = require('./prod');
} 
